import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition, HttpClient } from '@wix/sdk-types';
import {
  CheckoutSettings,
  CheckoutSettingsUpdatedEnvelope,
  GetCheckoutSettingsResponse,
  GetCheckoutSettingsResponseNonNullableFields,
  UpdateCheckoutSettingsResponse,
  UpdateCheckoutSettingsResponseNonNullableFields,
  getCheckoutSettings as universalGetCheckoutSettings,
  updateCheckoutSettings as universalUpdateCheckoutSettings,
} from './ecom-v1-checkout-settings-checkout-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getCheckoutSettings(
  httpClient: HttpClient
): GetCheckoutSettingsSignature {
  return () =>
    universalGetCheckoutSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetCheckoutSettingsSignature {
  /**
   * Retrieves the sites' checkout settings.
   *
   *
   * The `getCheckoutSettings()` function returns a Promise that resolves to checkout settings.
   * @returns The requested checkout settings.
   */
  (): Promise<
    GetCheckoutSettingsResponse & GetCheckoutSettingsResponseNonNullableFields
  >;
}

export function updateCheckoutSettings(
  httpClient: HttpClient
): UpdateCheckoutSettingsSignature {
  return (checkoutSettings: CheckoutSettings) =>
    universalUpdateCheckoutSettings(
      checkoutSettings,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateCheckoutSettingsSignature {
  /**
   * Updates the sites' checkout settings.
   *
   *
   * The `updateCheckoutSettings()` function returns a Promise that resolves to the newly updated checkout settings.
   * @param - Checkout settings to update.
   * @returns The updated checkout settings.
   */
  (checkoutSettings: CheckoutSettings): Promise<
    UpdateCheckoutSettingsResponse &
      UpdateCheckoutSettingsResponseNonNullableFields
  >;
}

export const onCheckoutSettingsUpdated = EventDefinition(
  'wix.ecom.v1.checkout_settings_updated',
  true,
  (event: CheckoutSettingsUpdatedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
          ],
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [{ path: 'entity.checkoutBrand.header.logo.image' }],
        },
      ])
    )
)<CheckoutSettingsUpdatedEnvelope>();

export {
  ActionEvent,
  Alignment,
  BaseEventMetadata,
  CheckboxField,
  CheckoutBrand,
  CheckoutFields,
  CheckoutHeader,
  CheckoutPolicies,
  CheckoutSettings,
  CheckoutSettingsUpdatedEnvelope,
  ContactUsPolicy,
  CustomCheckoutPolicy,
  DeleteCheckoutSettingsRequest,
  DeleteCheckoutSettingsResponse,
  DigitalItemPolicy,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  EventMetadata,
  FocalPoint,
  GetCheckoutSettingsRequest,
  GetCheckoutSettingsResponse,
  GetCheckoutSettingsResponseNonNullableFields,
  GiftCardProviderWasProvisioned,
  IdentificationData,
  IdentificationDataIdOneOf,
  ListCheckoutSettingsRequest,
  ListCheckoutSettingsResponse,
  Logo,
  LogoSize,
  MessageEnvelope,
  PrivacyPolicy,
  RestoreInfo,
  ReturnPolicy,
  TermsAndConditionsPolicy,
  UpdateCheckoutSettingsRequest,
  UpdateCheckoutSettingsResponse,
  UpdateCheckoutSettingsResponseNonNullableFields,
  WebhookIdentityType,
} from './ecom-v1-checkout-settings-checkout-settings.universal.js';
